module.exports = __webpack_public_path__ + "assets/images/novasports_prime.7c7aa080834ae8a43f5f6b02bc13886f.png";